import { render } from "./ClaimDeductibleInformation.vue?vue&type=template&id=298c2df6"
import script from "./ClaimDeductibleInformation.vue?vue&type=script&lang=js"
export * from "./ClaimDeductibleInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__